import { defineStore } from 'pinia'
import { ref, toRaw } from 'vue'

function isIndexKey(key: string): boolean {
  return /^\d+$/.test(key)
}

function setNested(obj: Record<string, unknown>, path: (string | number)[], value: unknown): void {
  if (!path || path.length === 0) return
  let cur: Record<string, unknown> = obj

  for (let i = 0; i < path.length - 1; i++) {
    const key = String(path[i])
    const nextKey = String(path[i + 1])
    const needsArray = isIndexKey(nextKey)

    const existing = cur[key]
    const existingIsArray = Array.isArray(existing)
    const existingIsObject = typeof existing === 'object' && existing !== null

    if (!existingIsObject || existingIsArray !== needsArray) {
      cur[key] = needsArray ? [] : {}
    }

    cur = cur[key] as Record<string, unknown>
  }

  cur[String(path[path.length - 1])] = value
}

export const useCmsEditStore = defineStore('cmsEdit', () => {
  const data = ref<Record<string, unknown>>({})
  const globalData = ref<Record<string, unknown>>({})

  function set(path: string[], value: unknown, global: boolean = false) {
    if (global) {
      setNested(globalData.value, path, JSON.parse(JSON.stringify(toRaw(value))))
    } else {
      setNested(data.value, path, JSON.parse(JSON.stringify(toRaw(value))))
    }
  }

  function seed(initial: Record<string, unknown>, global: boolean = false) {
    if (global) {
      globalData.value = structuredClone(initial)
    } else {
      data.value = structuredClone(initial)
    }
  }

  function getAll(global: boolean = false) {
    return global ? toRaw(globalData.value) : toRaw(data.value)
  }

  function clear() {
    data.value = {}
  }

  return { data, globalData, set, seed, getAll, clear }
})
